/**
 * Detects if the image is potentially animatable based on URL extension.
 *
 * @param {string} url - The URL of the image to check
 * @returns {boolean} True if the URL suggests an animatable format
 */
export const detectAnimatableByUrl = (url: string): boolean => {
  const animatableExtensions = ['.gif', '.webp']
  const urlLower = url.toLowerCase()
  return animatableExtensions.some((ext) => urlLower.includes(ext))
}

/**
 * Checks if an image is actually animated (has multiple frames) by fetching and analyzing its data.
 *
 * @param {string} url - The URL of the image to check
 * @returns {Promise<boolean>} True if the image is animated
 */
export const checkIfAnimated = async (url: string): Promise<boolean> => {
  return detectAnimatableByUrl(url)
}
